import React from 'react';
import { useTranslation } from 'react-i18next';
import InventoryList from './InventoryList';
import { ownedCollections, sharedCollections } from '../shell/collections';
import { Button, Checkbox, EmptyState, PageHeader } from '../ui';
import { BoxIcon, PlusIcon } from '../ui/icons';

/**
 * "/" — the collections home: page header, the admin's "all accounts"
 * switch, and the collections as cards. (The shell's box searches every
 * collection on /search since phase 3; an old /?q= link just opens the home.)
 */
function CollectionsHome({ inventories, isAdmin, showAll, onShowAll, onCreateNew, ...listProps }) {
  const { t } = useTranslation();
  const owned = ownedCollections(inventories).length;
  const shared = sharedCollections(inventories).length;

  return (
    <>
      <PageHeader
        title={t('shell.myCollections')}
        subtitle={[
          t('shell.collectionCount', { count: owned }),
          shared > 0 ? t('shell.sharedCount', { count: shared }) : null,
        ].filter(Boolean).join(' · ')}
        actions={<Button icon={PlusIcon} onClick={onCreateNew}>{t('shell.newCollection')}</Button>}
      />
      {isAdmin && (
        <Checkbox
          className="collections-admin-toggle"
          checked={showAll}
          onChange={(e) => onShowAll(e.target.checked)}
          label={t('collections.showAllAccounts')}
        />
      )}
      <InventoryList
        inventories={inventories}
        showAll={isAdmin && showAll}
        emptyState={(
          <EmptyState
            icon={BoxIcon}
            title={t('shell.noCollections')}
            action={<Button icon={PlusIcon} onClick={onCreateNew}>{t('shell.newCollection')}</Button>}
          >
            <p>{t('collections.empty')}</p>
          </EmptyState>
        )}
        {...listProps}
      />
    </>
  );
}

export default CollectionsHome;
